import React from 'react';

const swatch = (backgroundColor) => ({
  width: 12,
  height: 12,
  borderRadius: 2,
  backgroundColor,
  border: '1px solid rgba(0,0,0,0.1)',
});

const item = { display: 'flex', alignItems: 'center', gap: 4 };

function StatusLegend() {
  return (
    <div
      className="status-legend"
      style={{ display: 'flex', alignItems: 'center', gap: '1rem', fontSize: '0.8rem', color: 'rgba(0,0,0,0.5)', marginLeft: 'auto' }}
    >
      <span style={item}>
        <span style={swatch('#FFE4EB')}></span>
        Aktivt
      </span>
      <span style={item}>
        <span style={swatch('#fff')}></span>
        Kommande
      </span>
      <span style={{ ...item, opacity: 0.25 }}>
        <span style={swatch('#fff')}></span>
        Utgånget
      </span>
    </div>
  );
}

export default StatusLegend;
